import React from 'react';
import PropTypes from 'prop-types';

const Azure = props => {
  const { color, size, ...otherProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      stroke="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="m11.145894,19.753274l5.538895,-0.978435l0.051308,-0.011932l-2.848199,-3.388725a481.99242,481.99242 0 0 1 -2.848199,-3.404237c0,-0.016705 2.94127,-8.116235 2.957975,-8.144872c0.004773,-0.009546 2.006984,3.445999 4.851604,8.376355l4.880241,8.45988l0.03699,0.064434l-9.052907,-0.001193l-9.052907,-0.001193l5.4852,-0.968889l0,-0.001193zm-10.864204,-1.030936c0,-0.004773 1.342365,-2.335118 2.983032,-5.178544l2.983032,-5.170192l3.475829,-2.917406c1.911527,-1.603678 3.480602,-2.918599 3.487762,-2.920985a0.610925,0.610925 0 0 1 -0.056081,0.140799l-3.775326,8.09595l-3.707313,7.950378l-2.695468,0.00358c-1.481971,0.002386 -2.695468,0 -2.695468,-0.004773l0,0.001193z"/>
    </svg>

  );
};

Azure.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Azure.defaultProps = {
  color: 'currentColor',
  size: '24',
};

export default Azure;
